/* eslint-disable react-hooks/exhaustive-deps */
import { Dispatch, FC, SetStateAction, useEffect } from "react";
import { CircularProgressbar } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import { colors } from "@ht/shared/theme/index";
interface IProps {
    loading: boolean;
    progress: number;
    setProgress: Dispatch<SetStateAction<number>>;
    position?: "FULL_WINDOW" | "FULL_PARENT";
}
const CircularProgress: FC<IProps> = ({
    loading,
    progress,
    setProgress,
    position = "FULL_WINDOW",
}) => {
    useEffect(() => {
        if (progress == 1 && !loading) setProgress(0);
    }, [progress]);

    const style = {
        path: { stroke: colors.primary.DEFAULT },
        trail: { stroke: colors.primary["300"] },
    };
    return loading ? (
        <div className="static z-[99]">
            {position == "FULL_WINDOW" && (
                <div className="absolute top-0 left-0 bg-white opacity-60 rounded-lg w-full h-full">
                    <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
                        <CircularProgressbar
                            className="w-10 h-10"
                            styles={style}
                            value={progress}
                            maxValue={1}
                        />
                    </div>
                </div>
            )}
            {position == "FULL_PARENT" && (
                <CircularProgressbar
                    className="w-7 h-7 z-50"
                    styles={style}
                    value={progress}
                    maxValue={1}
                />
            )}
        </div>
    ) : (
        <></>
    );
};

export default CircularProgress;
